import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import IMG from "../../assets/images/icon2.png";
import whats from "../../assets/icons/whatsApp.svg";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getRentHouseNumber } from "../../network";

export default function RentCard() {
  const [whatsAppNum, setWhatsAppNum] = useState(null);
  const { dir } = useSelector((state) => state.language);
  const { t } = useTranslation();

  useEffect(() => {
    getRentHouseNumber((res) => {
      setWhatsAppNum(res.data);
    });
  }, []);

  const isMobile = /iPhone|Android|iPad|iPod/i.test(navigator.userAgent);
  const link = isMobile
    ? `https://wa.me/${whatsAppNum}`
    : `https://web.whatsapp.com/send?phone=${whatsAppNum}`;

  return (
    <div dir={dir} className="items__card row mx-0 align-items-md-center">
      <div className="col-md-6 px-0">
        <div
          className="items__fig w-100 position-relative"
          style={{
            backgroundColor: "#001c30",
            borderRadius: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            // className="items__img"
            src={IMG}
            alt="rent-warehouse"
            style={{
              maxWidth: "80%",
              maxHeight: "70%",

              display: "inline-block",
              objectFit: "cover",
            }}
          />
        </div>
      </div>
      <div className="items__text-holder col-md-6 px-0 px-md-3">
        <div className="flex-fill px-md-3 px-xxl-4 d-flex flex-column ">
          <h2 className="items__paragraph fsize-4  text-center">
            {t("rent.header")}
          </h2>
          <div className="row mx-0 mb-3 mb-md-4 align-self-stretch align-self-md-center fsize-6">
            {t("rent.description")}
          </div>
          {whatsAppNum && (
            <Link
              to={link}
              target="_blank"
              rel="noopener noreferrer"
              role="button"
            >
              <img src={whats} alt="contact" />
              {/* <WhatsAppOutlined
                className="recycle-nav__nav-icon"
                style={{
                  fontSize: "32px",
                  color: "#13c156",
                }}
              /> */}
              {/* <span className="recycle-nav__nav-titles text-center fsize-12">
              {t("nav.concierge")}
            </span> */}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
